/*
 * @Description:
 * @Author: -898-
 * @Date: 2025-03-10 11:07:37
 * @LastEditTime: 2026-06-22 10:59:41
 * @LastEditors: zZZz
 */
import request from "@/utils/request";

// 获取验证码
export function getCodeImg() {
  return request({
    url: "/code",
    headers: {
      isToken: false,
    },
    method: "get",
    timeout: 20000,
  });
}

// 获取手机验证码
export function getPhoneCode(data) {
  return request({
    url: "/auth/smsCode",
    method: "get",
    params: data,
  });
}

// 获取滑块验证码初始化数据
export function getSlideCaptcha(data) {
  return request({
    url: "/captcha/slide/captcha/get",
    method: "post",
    data,
  });
}

// 校验滑块验证码
export function checkSlideCaptcha(data) {
  return request({
    url: "/captcha/slide/captcha/check",
    method: "post",
    data,
  });
}

// 验证是否认证
export function isAuth() {
  return request({
    url: "/supplier/isAuth",
    method: "get",
  });
}
export function login(data) {
  // const userType = '00';
  return request({
    url: "/auth/login",
    headers: {
      isToken: false,
    },
    method: "post",
    data: data,
  });
}
// 获取用户详细信息
export function getInfo() {
  return request({
    url: "/system/user/getInfo",
    method: "get",
  });
}
// 忘记密码 发送验证码
export function sendVerifyCode(data) {
  return request({
    url: "/system/user/resetPwd/sendVerifyCode",
    headers: {
      isToken: false,
    },
    method: "get",
    params: data,
  });
}

// 忘记密码 校验验证码
export function checkVerifyCode(data) {
  return request({
    url: "/system/user/resetPwd/checkVerifyCode",
    headers: {
      isToken: false,
    },
    method: "post",
    data: data,
  });
}

// 忘记密码 重置密码
export function executeUser(data) {
  return request({
    url: "/system/user/resetPwd/execute",
    headers: {
      isToken: false,
    },
    method: "post",
    data: data,
  });
}
// 专家验证是否认证
export function isAuthExpert() {
  return request({
    url: "/expert/isAuth",
    method: "get",
  });
}
// 采购验证是否认证
export function isAuthPur() {
  return request({
    url: "/purchase/isAuth",
    method: "get",
  });
}
// 供应商验证是否认证
export function isAuthSupplier() {
  return request({
    url: "/supplier/isAuth",
    method: "get",
  });
}
